import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button as AntButton } from 'common/components/antd/Button/Button';

export const SWrapper = styled.div<{ active: boolean }>`
  ${(props): any =>
    props.active &&
    css`
      .custom-ant-btn {
        background-color: #f0f0f0 !important;
        border-color: black !important;
      }
    `}
`;

export const SButton = styled(AntButton)`
  line-height: 21px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SInner = styled.div`
  margin-left: 8px;
`;
